<template>
  <v-card>
    <v-card-title>{{ $t('competitor.applications') }}</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="this.filteredApplications"
        hide-default-headers
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.application.title="{item}">
          <router-link :to="'/app/applications/'+item.application.id">{{ item.application.title }}</router-link>
        </template>
        <template v-slot:item.application.assignedCategory.name="{item}">
          {{ item.application.assignedCategory ? item.application.assignedCategory.name : $t('application.unassigned') }}
        </template>
        <template v-slot:item.application.applicationType="{item}">
          {{ applicationType(item.application.applicationType) }}
        </template>
        <template v-slot:item.application.status="{item}">
          <v-icon v-if="item.application.status == 'Canceled'" color="red">cancel</v-icon>
            <span v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="green" v-if="item.application.paymentConfirmed">attach_money</v-icon>
                  <v-icon v-on="on" color="red" v-else>attach_money</v-icon>
                </template>
                <span>Payment confirmation</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="green" v-if="item.application.participationConfirmed">group</v-icon>
                  <v-icon v-on="on" color="red" v-else>group</v-icon>
                </template>
                <span>Participation confirmation</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="green" v-if="item.application.competitorsCheckedIn">create</v-icon>
                  <v-icon v-on="on" color="red" v-else>create</v-icon>
                </template>
                <span>Check-ins</span>
              </v-tooltip>
            </span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
  } from 'vuetify/lib'
  import fccapi from '../../fccapi.js'

  export default {
    name: 'FCCCompetitorApplications',
    computed: {
      headers: function(){
        return [
          { text: this.$t('application.title'), value: 'application.title', align: 'left' },
          { text: this.$t('application.category'), value: 'application.assignedCategory.name', align: 'left' },
          { text: this.$t('application.type'), value: 'application.applicationType', align: 'left' },
          { text: this.$t('application.competition'), value: 'application.competition.title', align: 'left' },
          { text: this.$t('ctrl.status'), value: 'application.status', align: 'left' },
        ];
      },
      filteredApplications: function(){
        var s = this.$store;
        return this.items.filter(i => i.application.competitionId == s.getters['competitionId']);
      }
    },
    methods: {
        applicationType: function(i) {
        return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
      }
    },
    data: ()=>({
      items: []
    }),
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable
    },
    mounted: function(){
      fccapi.get(`competitors/${this.$route.params.id}/applications`).then((r) => {
          this.items = r.data;
      })
    }
  }
</script>